<template>
  <v-app :class="page">
    <Navbar v-if="login == true"/>
    <Toolbar v-if="login == true"/>
    <v-content>
      <v-container
        :class="{'fill-height': login !== true }">
        <router-view />
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
import Navbar from './components/core/Navbar'
import Toolbar from './components/core/Toolbar'

export default {
  name: 'App',
  components: {
    Navbar,
    Toolbar
  },
  props: {},
  data () {
    return {
      clipped: false,
      page: '',
      login: false
    }
  },
  watch: {
    '$route' (val) {
      this.login = val.meta.requiresAuth
    }
  }
}
</script>
<style >
</style>



// WEBPACK FOOTER //
// src/App.vue